"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UtilityButtonVariant = exports.UtilityButtonColorScheme = void 0;
let UtilityButtonColorScheme = exports.UtilityButtonColorScheme = /*#__PURE__*/function (UtilityButtonColorScheme) {
  UtilityButtonColorScheme["Default"] = "default";
  UtilityButtonColorScheme["ColoredBackground"] = "coloredBackground";
  return UtilityButtonColorScheme;
}({});
let UtilityButtonVariant = exports.UtilityButtonVariant = /*#__PURE__*/function (UtilityButtonVariant) {
  UtilityButtonVariant["Tertiary"] = "tertiary";
  UtilityButtonVariant["TertiaryInline"] = "tertiaryInline";
  UtilityButtonVariant["TertiaryInlineWithUnderline"] = "tertiaryInlineWithUnderline";
  return UtilityButtonVariant;
}({});